import * as a from 'actions/colorGroups';

const initial = {
  data: [],
  error: null,
};

const colorGroups = (state = initial, action = null) => {
  switch (action.type) {
    case a.SET_COLORS:
      return {
        ...state,
        data: action.colors,
        error: null,
      };
    case a.SET_COLORS_ERROR:
      return {
        ...state,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default colorGroups;
